function saveSearch(name, query, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/savedsearch`;
  return apiClient.post(route, { name, query });
}

function replaceSearch(name, query, searchId, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/savedsearch/${searchId}`;
  return apiClient.patch(route, { name, query });
}

export default {
  saveSearch,
  replaceSearch
};



// WEBPACK FOOTER //
// ./app/api/SavedSearchApi.js